import { useEffect } from 'react'
import { AppLayout } from './app/AppLayout'
import { DetailPanel } from './features/detail'
import { FilterPanel } from './features/filters'
import { MapCanvas } from './features/map'
import { LanguageProvider, useLanguage } from './i18n'
import { useUrlSync } from './state/useUrlSync'

/**
 * The application.
 *
 * Everything the three panels have to say to each other goes through the store
 * in `state/`: filters and the query drive what the map's source contains, the
 * map publishes what matched, a selection from any of the three opens the detail
 * panel and flies the camera, and `state/useUrlSync` keeps the address bar equal
 * to all of it. No panel imports another.
 */

/** Keeps `<html lang>` honest, so a screen reader switches voice with the picker. */
const useDocumentLanguage = (): void => {
  const { language } = useLanguage()

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])
}

const AppShell = () => {
  useUrlSync()
  useDocumentLanguage()

  return <AppLayout filters={<FilterPanel />} map={<MapCanvas />} detail={<DetailPanel />} />
}

export const App = () => (
  <LanguageProvider>
    <AppShell />
  </LanguageProvider>
)
